const CRESIVOX_PROXY_PATH = '/api/cresivox';

export const getCresivoxBaseUrl = () => {
  // if (typeof window !== 'undefined') {
  //   return CRESIVOX_PROXY_PATH;
  // }

  return process.env.NEXT_PUBLIC_CRESIVOX_BASE_URL || CRESIVOX_PROXY_PATH;
};

export { CRESIVOX_PROXY_PATH };
